import { render, staticRenderFns } from "./FabricForm.vue?vue&type=template&id=9c90eb78&scoped=true"
import script from "./FabricForm.vue?vue&type=script&lang=js"
export * from "./FabricForm.vue?vue&type=script&lang=js"
import style0 from "./FabricForm.vue?vue&type=style&index=0&id=9c90eb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c90eb78",
  null
  
)

export default component.exports